// El hub de aplicaciones (DA-9): apps.nara.chat. Ahí se entra una vez para
// todas las aplicaciones de NARA; deja una cookie de sesión de un día para
// todo .nara.chat que el backend del ERP reconoce.
export const HUB = process.env.REACT_APP_HUB_URL || 'https://apps.nara.chat';

/** Cierra la sesión del hub (la cookie es suya, solo él puede borrarla) y
 *  termina en la entrada del hub: el hub es la puerta de todas las
 *  aplicaciones, no la pantalla de entrada de cada una. */
export function salirDelHub() {
  window.location.href = `${HUB}/api/salir?volver=${encodeURIComponent(HUB + '/')}`;
}

/** Entrar es ir al hub: después de entrar, ahí se ven las aplicaciones.
 *  También «Salir» de la aplicación vuelve aquí sin cerrar la sesión del hub
 *  (2026-10-30, Raúl): de todo se sale en el hub. Sin dejar la aplicación en
 *  el historial, para que «atrás» no rebote. */
export function irAlHub() {
  window.location.replace(`${HUB}/`);
}
